/*
 * Copyright (c) 2018.  Spin in het Web BV Apeldoorn
 * Geen toestemming zonder gebruik zonder schriftelijke overeenkomst
 * Ook bij schriftelijke overeenkomst is het gebruik van deze code
 * beperkt tot de in de overeenkomst opgenomen voorwaarden.
 */

/**
 * SPIN IN HET WEB APELDOORN
 * User: Jelmer Jellema
 * Date: 18-4-2018
 * Time: 12:51
 *
 *
 */

angular.module('sihw.helpers',[])
.factory('sihwhelpers',[function() {
    return {
        isEmpty: function(v)
        {
            return (v === null || v === undefined || v === '' || Number.isNaN(v));
        }
    }
}]);